export const arrayFrom = <T>(xs: ArrayLike<T>) => Array.from(xs);
